<template>
  <nuttrema-layout-content>
    <nuttrema-empty-result icon="far fa-volume-mute" slot="central">
      <template slot="text">
        <h1>404</h1>
        <h4>Page not found...</h4>
      </template>
    </nuttrema-empty-result>
  </nuttrema-layout-content>
</template>
<script>
import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import NuttremaEmptyResult from 'components/ui/panels/nuttrema-empty-result';

export default {
  name: 'page-404',
  components: {
    NuttremaLayoutContent,
    NuttremaEmptyResult,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/auth/page-404.vue